import React, { useState } from 'react';
import NavBar from './Components/navbar';
import Carrossel from './Components/Carrossel/Carrossel';
import './App.css';
import MyForm from './Components/formulario';
import foto from './Foto Portfolio.jpg';
import { ReactComponent as FirstSVG } from "./svg's/firstIcons.svg";
import { ReactComponent as SecondSVG } from "./svg's/secondIcons.svg";
import { ReactComponent as ThirdIcon } from "./svg's/thirdIcon.svg";

function App() {

  const data = new Date();
  let experiencie = data.getFullYear() - 2021
  const [showHardSkills, setShowHardSkills] = useState(true);
  const [selectedButton, setSelectedButton] = useState(null);

  return (
    <>
      <NavBar />
      <section id='home'>
        <h1>Bem-vindo ao meu portfólio!</h1>
        <div>
          <p>
            {/* Bem-vindo ao meu portfólio! Sou um programador com mais de {experiencie} anos de experiência e habilidades em tecnologias como HTML, CSS, JavaScript, ReactJS, SCSS e Bootstrap. Além disso, tenho interesse em banco de dados, processamento de dados e automação de processos, o que me permite trazer um conjunto único de habilidades para qualquer projeto em que trabalho.<br/><br/>
            No meu portfólio, você encontrará uma lista de projetos que já trabalhei, incluindo um site de comércio eletrônico que desenvolvi usando banco de dados MySQL e PHP. Sinta-se à vontade para dar uma olhada nos detalhes de cada projeto e ver o meu trabalho em ação.<br/><br/>
            Se você estiver procurando por um programador confiável e apaixonado por tecnologia, eu gostaria de me candidatar para o seu projeto. Por favor, não hesite em entrar em contato comigo pelo meu endereço de e-mail ou pelo meu perfil no LinkedIn para discutir como posso ajudá-lo a alcançar seus objetivos de negócios. Obrigado por visitar meu portfólio e espero poder trabalhar com você em breve!<br/> */}
            Sou um programador apaixonado por tecnologia e resolução de problemas usando algoritmos. Graduando em Ciência da Computação e experiência em linguagens como C, Python e Java, estou focado em desenvolvimento backend.
            <br /><br />
            Tenho habilidades em análise de dados com Python e familiaridade com JavaScript. Estou pronto para colaborar em projetos desafiadores e oferecer soluções inovadoras. Aguardo seu contato para discutirmos como posso contribuir para o sucesso do seu projeto!
          </p>
          <div>
            <img
              alt='Minha imagem'
              width={"120%"}
              src={foto}
            />
          </div>
        </div>
      </section>
      <section id='skills'>
        <h1 style={{ margin: "auto", display: "block" }}>Habilidades</h1>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            className={`button ${selectedButton === 'hard' ? 'selected' : ''}`}
            onClick={() => {
              setShowHardSkills(true);
              setSelectedButton('hard');
            }}
          >
            Hardskills
          </button>
          <button
            className={`button ${selectedButton === 'soft' ? 'selected' : ''}`}
            onClick={() => {
              setShowHardSkills(false);
              setSelectedButton('soft');
            }}
          >
            Softskills
          </button>
        </div>

        {showHardSkills ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h5>Linguagens de Programação (Avançado):</h5>
            <p>JavaScript, PHP, Python</p>
            <h5>Bibliotecas e Frameworks (Intermediário):</h5>
            <p>ReactJS, Django, Bootstrap</p>
            <h5>Banco de Dados (Avançado):</h5>
            <p>MySQL</p>
            <h5>Desenvolvimento Web (Avançado):</h5>
            <p>HTML, CSS, SCSS</p>
            <h5>Ferramentas e Metodologias (Intermediário):</h5>
            <p>Git & GitHub, CI/CD com Jenkins, Metodologias Ágeis (Scrum e Kanban)</p>
            <h5>Sistema Operacional (Avançado):</h5>
            <p>Linux Mint</p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h5>Resolução de Problemas (Avançado):</h5>
            <p> Habilidade de analisar e solucionar problemas técnicos complexos.</p>
            <h5>Comunicação (Intermediário):</h5>
            <p> Capacidade de trabalhar em equipe e comunicar ideias de forma clara e eficaz.</p>
            <h5>Adaptabilidade (Avançado):</h5>
            <p>Disposição para aprender novas tecnologias e metodologias.</p>
          </div>
        )}

      </section>

      <section style={{ 'margin': 'auto' }} id='projetos'>
        <h1 style={{ 'display': 'block' }}>Projetos</h1>
        <p style={{ 'margin': 'auto' }}>
          Veja alguns dos meus projetos mais recentes e descubra como eu posso ajudá-lo em seus projetos. Clique nos cards abaixo para explorar mais a fundo o meu trabalho e entrar em contato comigo para discutir como eu posso ajudá-lo a alcançar seus objetivos.
        </p>
        <br />
        <Carrossel />
      </section>

      <section
        style={{
          'display': 'flex',
          'justify-content': 'space-between'
        }} id='contato'>
        <div style={{ 'display': "flex", "flex-direction": "column", "width": '70%', 'justify-content': 'space-between' }}>
          <h1>Entre em contato</h1>
          <p>
            Estou sempre aberto a novos projetos e oportunidades de colaboração. Sinta-se à vontade para entrar em contato comigo pelo formulário ao lado ou pelas minhas mídias sociais.
          </p>
          <div style={{ 'width': '12em' }}>
            <ThirdIcon />
          </div>
        </div>
        <MyForm />
      </section>
    </>
  )
}
export default App;